import { contentsType } from '../types';

const screenerContents: Array<contentsType> = [
  {
    title: 'Guru Screener',
    description:
      'Saring saham sesuai dengan kriteria guru investasi dunia seperti Warren Buffett, Peter Lynch, Piotroski dan lainnya.',
    image: 'Screener_Guru_Screener_Blue.jpg',
  },
  {
    title: '100+ Financial Metrics',
    description:
      'Manfaatkan database data keuangan kami yang luas untuk mencari dan memilah saham sesuai dengan kriteria yang dinginkan secara cepat dan tepat.',
    image: 'Screener_Financial_Metrics_Blue.jpg',
  },
  {
    title: 'Preset Screener',
    description:
      'Preset screener siap pakai yang berisi screener yang biasa digunakan oleh investor profesional seperti screneer untuk saham yang memiliki PE Strong Undervalued atau screener saham High Volume Breakout.',
    image: 'Screener_Preset_Screener_Blue.jpg',
  },
  {
    title: 'Ratio vs Ratio',
    description:
      'Gunakan perbandingan dua rasio berbeda sebagai kriteria dari screener buatanmu.',
    image: 'Screener_Ratio_Blue.jpg',
  },
];

export default screenerContents;
